import React from "react";
import PropTypes from "prop-types";
import WDMPTDGButtonCard from "./wdmptdg-button-card";
import { Grid } from "@mui/material";
import { getRandomColors } from "../../utils/utils";

const WDMPTDGGrid = ({ buttonCardsComponent }) => {
    const cardColors = getRandomColors(buttonCardsComponent?.length || 0, buttonCardsComponent?.name || "");

    return (
       <Grid
            container
            spacing={4}
            minHeight={700}
            width="calc(100% + 32px)"
            margin="-32px 0 0 -32px !important"
        >
            {buttonCardsComponent?.map((item, index) => (
                <Grid item key={index} xs={12} lg={6}>
                    <WDMPTDGButtonCard
                        cardColor={cardColors[index % cardColors.length]}
                        cardData={item}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

WDMPTDGGrid.propTypes = {
    buttonCardsComponent: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default WDMPTDGGrid;
